import Button from '@ui/Button'
import StackGrid from '@components/StackGrid'
import {ROUTES } from '@/constants'


export default function StackServices() {  

  return (
    <section id="stack-services" className="section-py stack-section" aria-labelledby="stack-services-heading" >
      <div className="container impact-grid">
        <div className="stack-content" data-aos="fade-right">
          <span className="impact-eyebrow">TOOLS &amp; TECHNOLOGIES</span>
          <h2 id="stack-services-heading" >
            <span className="impact-heading-dark">We Adapt,</span>
            <span className="impact-heading-light">You Benefit</span>
          </h2>
          <p>
            CruxBytes has a rich experience in working with emerging technologies and has built extensive experience in various programming languages, frameworks, libraries, and tools.</p>
            <p>We continuously experiment with new 
              technologies through our young talented engineers and pass on the learnings to our clients for a competitive edge.
          </p>
          <div className="impact-actions">
           
            <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right">
              Start a project
            </Button>
             <Button href={ROUTES.OUR_WORK} variant="outline"  >
              View Portfolio
            </Button>
          </div>
        </div>

        {/* <div className="stack-grid-wrap" data-aos="fade-left">
          <span className="stack-grid-lines" aria-hidden="true" />
          <div className="stack-grid">
            {GRID_ROWS.map((row, rIdx) => (
              <div
                key={rIdx}
                className="stack-grid-row"
                style={{ transform: `translateX(${shift * ROW_MULTIPLIER[rIdx]}px)` }}
              >
                {row.map((cell, cIdx) =>
                  cell ? (
                    <span key={cIdx} className={`stack-grid-icon stack-grid-icon--${COL_BLUR_TIER[cIdx]}`}>
                      <span className="stack-grid-badge">
                        <cell.Icon />
                      </span>
                    </span>
                  ) : (
                    <span key={cIdx} className="stack-grid-icon stack-grid-icon--empty" />
                  )
                )}
              </div>
            ))}
          </div>
        </div> */}
        <StackGrid />
      </div>
    </section>
  )
}